import { Component, Input, OnInit } from '@angular/core';
import { CertificateDisplayInfo } from 'src/app/services/certificate.service';

@Component({
  selector: 'app-certificate-instructions',
  templateUrl: './certificate-instructions.component.html',
  styleUrls: ['./certificate-instructions.component.css']
})
export class CertificateInstructionsComponent implements OnInit {

  @Input()
  certInfo: CertificateDisplayInfo;

  constructor() { }

  ngOnInit(): void {
  }

}
